import React from 'react';
import { formatTime } from '../../utils/time';
import AvailabilityCodeIcon from '../general/AvailabilityCodeIcon';

const TemplatePatternDetails = ({ pattern }) => {
  const { recurring_interval_schedule } = pattern;
  const schedule_intervals = recurring_interval_schedule.intervals || [];

  const path = `/groups/${pattern.group_id}/schedule/standby_duty_template_patterns/${pattern.id}`;

  return (
    <>
      {schedule_intervals.filter(interval => interval.available || interval.availability_code).length}{' '}
      {I18n.t('intervals')} {I18n.t('from')} {formatTime(recurring_interval_schedule.start_time)} {I18n.t('to')}{' '}
      {formatTime(recurring_interval_schedule.end_time)}.{' '}
      <div>
        {I18n.t(`schedules.standby_duty_template_patterns.${pattern.align_to_start ? 'aligned' : 'unaligned'}`)}
      </div>
      <div>
        {pattern.availability_codes.length > 0 &&
          I18n.t('schedules.standby_duty_template_patterns.availability_codes.carry_over')}{' '}
        {pattern.availability_codes.map(code => (
          <span className="me-1" key={code}>
            <AvailabilityCodeIcon code={code} />
          </span>
        ))}
      </div>
      <br />
      <a href={path} target="_blank" rel="noopener noreferrer">
        <strong>{I18n.t('more_details')}</strong>
      </a>
    </>
  );
};

export default TemplatePatternDetails;
